module.exports = __webpack_public_path__ + "img/icon23.010f8299.png";